/**
***  vivaForm
***  v1.7.2
***  @update 2023/04/30
**/



import axios from 'axios';
import './vivaform/immediateFunctions';
import { method } from './vivaform/method';
import { vf, typeArray } from './vivaform/elements';
import { isNodeList, modalOpenExec, modalCloseExec } from './vivaform/functions';
import { processValidation } from './vivaform/processValidation';
import './vivaform/inputDatetime';
import './vivaform/pikaday';



// inputDatetime
window.inputDatetime();



// vivaForm

window.vivaForm = (object) => {

  // 引数がオブジェクトでない場合は何もしない
  if( object instanceof Object === false ) return false;



  // パラメータをセットするオブジェクト
  global.Parameters = {
    form       : object.formname,
    rules      : object.rules ? object.rules : {},
    method     : null,
    addMethod  : object.method ? object.method : {},
    group      : object.group ? object.group : {},
    params     : {},
    valid      : {},
    scroll     : {}
  };

  // 標準メソッドと追加メソッドをマージしてグローバルパラメータにセットする
  Parameters.method = Object.assign( method, Parameters.addMethod );



  // ---------- ---------- ---------- ----------



  // フォーム要素を取得する
  global.vivaForm = document.forms[Parameters.form];

  // フォーム要素が存在しない場合は何もしない
  if( !vivaForm )return false;

  // フォームエレメント
  global.vivaFormElements = vivaForm.elements;

  // フォームの最後の子要素として追加
  const insertTextarea = '<textarea name="submitValues" hidden></textarea><input type="hidden" name="sendValidity" id="sendValidity">';
  vivaForm.insertAdjacentHTML('beforeend', insertTextarea);



  // フォームエレメントをループしてイベントをセットする
  for( let i = 0; i < vivaFormElements.length; i++ ){

    // 変数の定義
    const element  = vivaFormElements[i],
          name     = element.name,
          type     = element.type,
          target   = vivaFormElements[name];

    // イベントセット
    element.addEventListener('change', (e) => {
      processValidation( target );
    });

    // タイプによってイベントを変える
    //if( typeArray[0].includes(type) ){
    //  element.addEventListener('focusout', (e) => {
    //    processValidation( target );
    //  });
    //};

    //if( typeArray[1].includes(type) ){
    //  element.addEventListener('change', (e) => {
    //    processValidation( target );
    //  });
    //};
  };



  // 入力内容を確認するボタンイベント
  vf.verifyExecBtn.addEventListener('click', () => {

    // 値をリセット
    Parameters.params = {}; // readonly属性があると（changeイベントが発生しないため）並び順が保証されないので再度取得し直す
    Parameters.valid  = [];
    Parameters.scroll = {};

    // フォーム全体をループ処理
    for( let i = 0; i < vivaFormElements.length; i++ ){

      // 変数の定義
      const element  = vivaFormElements[i],
            name     = element.name,
            type     = element.type,
            target   = vivaFormElements[name];



      // button 要素は処理しない
      if( type === 'button' || type === 'submit' ) continue;



      /**
      *** display none の要素は無視する
      *** 親要素の display: none により内包されている子要素は display: none が継承されないため高さを取得して判別する
      *** hidden 属性は除外する
      *** data 属性の force が true のものは除外
      *** disabled 属性が true のものは除外
      **/
      if( ( !element.offsetHeight && !element.hidden ) && (element.dataset.force === undefined) || element.disabled ) continue;



      // バリデーションの結果を取得
      Parameters.valid.push( processValidation(target) );

    }; // フォーム全体をループ処理 END



    // Last Validation
    if( Parameters.valid.includes(false) ){

      // エラーのある箇所へスクロールさせる
      const positions = Object.values(Parameters.scroll);
      const minPosition = Math.min(...positions);
      if( isFinite(minPosition) ){ // isFinite() 渡された値が有限数であるかどうかを判断
        window.scrollTo({
          top: minPosition - (window.innerHeight / 3),
          left: 0,
          behavior: 'smooth'
        });
      }

      return;

    };



    // textarea[name="submitValues"] に value を設定する
    vivaForm.submitValues.value = JSON.stringify( Parameters.params, null, '   ' );



    // Verify Modal
    axios({
      method: 'POST',
      url: './verify.export.php',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify( Parameters.params )
    })
    .then(function (res) {
      modalOpenExec(res.data);
    })
    .catch(function (error) {
      console.log(error);
    });

  });



  // 入力画面にもどるボタンイベント
  vf.close.addEventListener('click', () => {
    modalCloseExec();
  });



  // 送信する
  vf.submitExecBtn.addEventListener('click', function(e){
    e.preventDefault();

    let config;
    // sendValidity の情報を取得する
    const sendValidityJson = document.getElementById('sendValidityJson') || undefined;
    if( sendValidityJson ) config = sendValidityJson.textContent ? sendValidityJson.textContent : undefined;
    const sendValidity = document.getElementById('sendValidity');
    sendValidity.value = config;

    vivaForm.submit();

  });

};
